export default __webpack_public_path__ + "static/media/38C3A6E1-1D71-4036-BCC1-BEE3702130ED.c81de72b.mov";